import React__default from 'react';
import { SvgImg } from '../../components/svgImg/svgImg.js';

const Close = ({ viewbox = '0 0 32 32', width, height, fill = '#929292' }) => (React__default.createElement(SvgImg, { viewbox: viewbox, title: "icon close", width: width, height: height },
    React__default.createElement("g", { fill: fill, fillRule: "evenodd" },
        React__default.createElement("g", { id: "ic_close" },
            React__default.createElement("polygon", { id: "path-1", points: "27 6.45 25.55 5 16 14.55 6.45 5 5 6.45 14.55 16 5 25.55 6.45 27 16 17.45 25.55 27 27 25.55 17.45 16 27 6.45" })))));

export { Close as default };
